import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { fetchMyWork, type MyWork } from '@/api/work';
import { useAuth } from '@/auth/useAuth';

/** How long the work is trusted when no message says it changed. */
export const WORK_REFETCH_MS = 60_000;

/**
 * The signed-in person's waiting work.
 *
 * The key starts with `work`, so the live hooks of the pipeline and the board, and the work topic
 * itself, can all refresh it with one invalidation. The identity follows, as it does on every
 * other per-person query, so signing in as somebody else never shows the last person's list.
 *
 * @returns the query for the sections of work
 */
export function useWork(): UseQueryResult<MyWork> {
  const { identity } = useAuth();
  return useQuery({
    queryKey: ['work', identity],
    queryFn: fetchMyWork,
    enabled: identity !== null,
    refetchInterval: WORK_REFETCH_MS,
    refetchOnWindowFocus: true,
  });
}
